export default __webpack_public_path__ + "static/media/financas4.b1992f0e.jpg";